// Approximate [lat, lng] for common Singapore neighbourhoods
const AREAS = {
  tuas: [1.32, 103.63],
  'jurong west': [1.3404, 103.709],
  'jurong east': [1.3329, 103.7436],
  'boon lay': [1.3389, 103.7053],
  'choa chu kang': [1.384, 103.747],
  'bukit panjang': [1.3774, 103.7637],
  'bukit batok': [1.359, 103.7637],
  clementi: [1.3151, 103.7649],
  queenstown: [1.2942, 103.806],
  'bukit timah': [1.3294, 103.8021],
  'bukit merah': [1.2819, 103.8239],
  'tiong bahru': [1.286, 103.828],
  orchard: [1.3048, 103.8318],
  novena: [1.3203, 103.8438],
  'toa payoh': [1.3343, 103.8563],
  bishan: [1.3526, 103.8352],
  'ang mo kio': [1.3691, 103.8454],
  yishun: [1.4304, 103.8354],
  sembawang: [1.4491, 103.8185],
  woodlands: [1.4382, 103.789],
  'yew tee': [1.3971, 103.7474],
  sengkang: [1.3868, 103.8914],
  punggol: [1.4043, 103.902],
  hougang: [1.3612, 103.8863],
  serangoon: [1.3554, 103.8679],
  kovan: [1.36, 103.885],
  'pasir ris': [1.373, 103.949],
  tampines: [1.3496, 103.9568],
  changi: [1.3644, 103.9915],
  bedok: [1.3236, 103.9273],
  'marine parade': [1.302, 103.907],
  katong: [1.305, 103.901],
  geylang: [1.3182, 103.883],
  kallang: [1.31, 103.871],
  'little india': [1.3066, 103.8517],
  chinatown: [1.281, 103.844],
  'marina bay': [1.281, 103.861],
  'pasir panjang': [1.2762, 103.791],
  'west coast': [1.305, 103.765],
  harbourfront: [1.2653, 103.82],
}

// Singapore's 28 postal districts: [lat, lng] anchor + the 2-digit postal sectors in it
const POSTAL_DISTRICTS = [
  [
    [1.284, 103.851],
    ['01', '02', '03', '04', '05', '06'],
  ], // Raffles Place, Marina
  [
    [1.276, 103.844],
    ['07', '08'],
  ], // Anson, Tanjong Pagar
  [
    [1.2942, 103.806],
    ['14', '15', '16'],
  ], // Queenstown, Tiong Bahru
  [
    [1.2653, 103.82],
    ['09', '10'],
  ], // Telok Blangah, HarbourFront
  [
    [1.2762, 103.791],
    ['11', '12', '13'],
  ], // Pasir Panjang, Clementi New Town
  [[1.293, 103.852], ['17']], // High Street, Beach Road
  [
    [1.2996, 103.8558],
    ['18', '19'],
  ], // Middle Road, Golden Mile
  [
    [1.3066, 103.8517],
    ['20', '21'],
  ], // Little India
  [
    [1.3048, 103.8318],
    ['22', '23'],
  ], // Orchard, River Valley
  [
    [1.311, 103.793],
    ['24', '25', '26', '27'],
  ], // Bukit Timah, Holland, Tanglin
  [
    [1.3203, 103.8438],
    ['28', '29', '30'],
  ], // Novena, Thomson
  [
    [1.3343, 103.8563],
    ['31', '32', '33'],
  ], // Balestier, Toa Payoh
  [
    [1.332, 103.869],
    ['34', '35', '36', '37'],
  ], // Macpherson, Braddell
  [
    [1.3182, 103.883],
    ['38', '39', '40', '41'],
  ], // Geylang, Eunos
  [
    [1.305, 103.901],
    ['42', '43', '44', '45'],
  ], // Katong, Joo Chiat
  [
    [1.3236, 103.9273],
    ['46', '47', '48'],
  ], // Bedok, Upper East Coast
  [
    [1.3644, 103.9915],
    ['49', '50', '81'],
  ], // Loyang, Changi
  [
    [1.3496, 103.9568],
    ['51', '52'],
  ], // Tampines, Pasir Ris
  [
    [1.3612, 103.8863],
    ['53', '54', '55', '82'],
  ], // Serangoon Garden, Hougang, Punggol
  [
    [1.3526, 103.8352],
    ['56', '57'],
  ], // Bishan, Ang Mo Kio
  [
    [1.345, 103.777],
    ['58', '59'],
  ], // Upper Bukit Timah, Clementi Park
  [
    [1.3329, 103.7436],
    ['60', '61', '62', '63', '64'],
  ], // Jurong
  [
    [1.3774, 103.7637],
    ['65', '66', '67', '68'],
  ], // Bukit Panjang, Choa Chu Kang
  [
    [1.39, 103.71],
    ['69', '70', '71'],
  ], // Lim Chu Kang, Tengah
  [
    [1.43, 103.762],
    ['72', '73'],
  ], // Kranji, Woodgrove
  [
    [1.38, 103.832],
    ['77', '78'],
  ], // Upper Thomson, Springleaf
  [
    [1.4304, 103.8354],
    ['75', '76'],
  ], // Yishun, Sembawang
  [
    [1.405, 103.868],
    ['79', '80'],
  ], // Seletar
]

const SECTOR_ANCHOR = Object.fromEntries(
  POSTAL_DISTRICTS.flatMap(([anchor, sectors]) => sectors.map((sector) => [sector, anchor]))
)

export const AREA_NAMES = Object.keys(AREAS).map((name) =>
  name.replace(/\b\w/g, (char) => char.toUpperCase()))

// Approximate [lat, lng] for a postal code (by its 2-digit sector) or a neighbourhood name
export const resolveLocation = (input) => {
  const raw = input.trim()
  if (/^\d{2,}$/.test(raw)) return SECTOR_ANCHOR[raw.slice(0, 2)] || null
  return AREAS[raw.toLowerCase()] || null
}
